module.exports = __webpack_public_path__ + "static/media/Group1152.223db1ca.png";